import AuthenticationService from '@/services/AuthenticationService';
import ActionService from "@/services/ActionService";

export default {
  data() {
    return {
      SurveyRevisionStatus: ActionService.SurveyRevisionStatus,
      SurveyRevisionResultAdjustment: ActionService.SurveyRevisionResultAdjustment,
      SurveyRevisionType: {
        Complaint: 0,
        General: 1
      },
      SurveyRevisionDocumentType: {
        Telephone: 'telephone',
        Email: 'email',
        Picture: 'picture',
        Video: 'video',
        Receipt: 'receipt',
        Other: 'other'
      },
      SurveyRevisionAttachmentScope: {
        Question: 'question',
        General: 'general'
      },
      SurveyRevisionRole: {
        Creator: 0,
        Contributor: 1,
        Agency: 2,
        Admin: 3
      },
      GeneralInquiryTopic: {
        ComplaintDeadline: 'complaint-deadline',
        UnderstandRating: 'understand-rating',
        GeneralInfo: 'general-info',
        Technical: 'technical',
        Evaluation: 'evaluation',
        ComplaintStatus: 'complaint-status',
        Documentation: 'documentation',
        Other: 'other'
      }
    };
  },

  computed: {
    isInquiryWizardEnabled() {
      return APP_TARGET === "skoda" || APP_TARGET === "audi";
    },

    isGeneralInquiryContactOptionEnabled() {
      return APP_TARGET !== "skoda";
    },

    getRevisionStatusOptions() {
      return [
        { value: this.SurveyRevisionStatus.New, text: this.getRevisionStatusText(this.SurveyRevisionStatus.New) },
        { value: this.SurveyRevisionStatus.Approved, text: this.getRevisionStatusText(this.SurveyRevisionStatus.Approved) },
        { value: this.SurveyRevisionStatus.Dismissed, text: this.getRevisionStatusText(this.SurveyRevisionStatus.Dismissed) },
        { value: this.SurveyRevisionStatus.DismissedCustom1, text: this.getRevisionStatusText(this.SurveyRevisionStatus.DismissedCustom1) },
        { value: this.SurveyRevisionStatus.DismissedCustom2, text: this.getRevisionStatusText(this.SurveyRevisionStatus.DismissedCustom2) },
        { value: this.SurveyRevisionStatus.DismissedCustom3, text: this.getRevisionStatusText(this.SurveyRevisionStatus.DismissedCustom3) },
        { value: this.SurveyRevisionStatus.InProgress, text: this.getRevisionStatusText(this.SurveyRevisionStatus.InProgress) },
        { value: this.SurveyRevisionStatus.InProgressAgency, text: this.getRevisionStatusText(this.SurveyRevisionStatus.InProgressAgency) },
        { value: this.SurveyRevisionStatus.InProgressCustom1, text: this.getRevisionStatusText(this.SurveyRevisionStatus.InProgressCustom1) },
        { value: this.SurveyRevisionStatus.InProgressCustom2, text: this.getRevisionStatusText(this.SurveyRevisionStatus.InProgressCustom2) },
        { value: this.SurveyRevisionStatus.Recheck, text: this.getRevisionStatusText(this.SurveyRevisionStatus.Recheck) },
        { value: this.SurveyRevisionStatus.Solved, text: this.getRevisionStatusText(this.SurveyRevisionStatus.Solved) },
        { value: this.SurveyRevisionStatus.Revised, text: this.getRevisionStatusText(this.SurveyRevisionStatus.Revised) },
        { value: this.SurveyRevisionStatus.RevisedApprovedGoodwill, text: this.getRevisionStatusText(this.SurveyRevisionStatus.RevisedApprovedGoodwill) },
        { value: this.SurveyRevisionStatus.RevisedApprovedCustom1, text: this.getRevisionStatusText(this.SurveyRevisionStatus.RevisedApprovedCustom1) },
        { value: this.SurveyRevisionStatus.RevisedApprovedCustom2, text: this.getRevisionStatusText(this.SurveyRevisionStatus.RevisedApprovedCustom2) },
        { value: this.SurveyRevisionStatus.RevisedApprovedCustom3, text: this.getRevisionStatusText(this.SurveyRevisionStatus.RevisedApprovedCustom3) },
        { value: this.SurveyRevisionStatus.RevisedApproved, text: this.getRevisionStatusText(this.SurveyRevisionStatus.RevisedApproved) },
        { value: this.SurveyRevisionStatus.RevisedDismissed, text: this.getRevisionStatusText(this.SurveyRevisionStatus.RevisedDismissed) },
        { value: this.SurveyRevisionStatus.RevisedDismissedCustom1, text: this.getRevisionStatusText(this.SurveyRevisionStatus.RevisedDismissedCustom1) },
        { value: this.SurveyRevisionStatus.RevisedDismissedCustom2, text: this.getRevisionStatusText(this.SurveyRevisionStatus.RevisedDismissedCustom2) },
        { value: this.SurveyRevisionStatus.RevisedDismissedCustom3, text: this.getRevisionStatusText(this.SurveyRevisionStatus.RevisedDismissedCustom3) },
        { value: this.SurveyRevisionStatus.Done, text: this.getRevisionStatusText(this.SurveyRevisionStatus.Done) },
        { value: this.SurveyRevisionStatus.Answered, text: this.getRevisionStatusText(this.SurveyRevisionStatus.Answered) },
        { value: this.SurveyRevisionStatus.Published, text: this.getRevisionStatusText(this.SurveyRevisionStatus.Published) }
      ];
    },

    resultAdjustmentOptions() {
      return [
        { value: this.SurveyRevisionResultAdjustment.Adjusted, text: this.$t('Webportal.Actions.SurveyRevision.ResultAdjustment.True'), resultAdjustment: true },
        { value: this.SurveyRevisionResultAdjustment.AdjustedGoodwill, text: this.$t('Webportal.Actions.SurveyRevision.ResultAdjustment.TrueGoodwill'), resultAdjustment: true },
        { value: this.SurveyRevisionResultAdjustment.AdjustedShopperMistake, text: this.$t('Webportal.Actions.SurveyRevision.ResultAdjustment.TrueShopperMistake'), resultAdjustment: true },
        { value: this.SurveyRevisionResultAdjustment.NotAdjusted, text: this.$t('Webportal.Actions.SurveyRevision.ResultAdjustment.False'), resultAdjustment: false }
      ];
    },

    resultAdjustmentMap() {
      const map = new Map();
      this.resultAdjustmentOptions.forEach(option => {
        map.set(option.value, option.resultAdjustment);
      });
      return map;
    },

    notificationSettingsRoute() {
      return this.$router.currentRoute.path.startsWith("/external") ?
        {name: 'ExternalNotificationSettings'} :
        {name: 'Notification settings'};
    },

    documentTypeOptions() {
      return [
        { value: null, text: this.$t('Webportal.Actions.InquiryWizard.Step1.PleaseSelect') },
        { value: this.SurveyRevisionDocumentType.Telephone, text: this.getDocumentTypeLabel(this.SurveyRevisionDocumentType.Telephone) },
        { value: this.SurveyRevisionDocumentType.Email, text: this.getDocumentTypeLabel(this.SurveyRevisionDocumentType.Email) },
        { value: this.SurveyRevisionDocumentType.Picture, text: this.getDocumentTypeLabel(this.SurveyRevisionDocumentType.Picture) },
        { value: this.SurveyRevisionDocumentType.Video, text: this.getDocumentTypeLabel(this.SurveyRevisionDocumentType.Video) },
        { value: this.SurveyRevisionDocumentType.Receipt, text: this.getDocumentTypeLabel(this.SurveyRevisionDocumentType.Receipt) },
        { value: this.SurveyRevisionDocumentType.Other, text: this.getDocumentTypeLabel(this.SurveyRevisionDocumentType.Other) },
      ];
    },

    scopeOptions() {
      return [
        { value: this.SurveyRevisionAttachmentScope.Question, text: this.$t('Webportal.Actions.InquiryWizard.Attachment.Scope.Question') },
        { value: this.SurveyRevisionAttachmentScope.General, text: this.$t('Webportal.Actions.InquiryWizard.Attachment.Scope.General') },
      ];
    },

    revisionInitialStatusId() {
      if (APP_TARGET === "fressnapf")
        return this.SurveyRevisionStatus.InProgressCustom1;
      else
        return this.SurveyRevisionStatus.New;
    },

    revisionInitialAssignedToRole() {
      return this.SurveyRevisionRole.Contributor;
    },

    revisionRoleOptions() {
      return [
        { value: this.SurveyRevisionRole.Creator, text: this.getRevisionRoleText(this.SurveyRevisionRole.Creator) },
        { value: this.SurveyRevisionRole.Contributor, text: this.getRevisionRoleText(this.SurveyRevisionRole.Contributor) },
        // For now, only allow assignment to Creator and Contributor roles
        // { value: this.SurveyRevisionRole.Agency, text: this.getRevisionRoleText(this.SurveyRevisionRole.Agency) },
        // { value: this.SurveyRevisionRole.Admin, text: this.getRevisionRoleText(this.SurveyRevisionRole.Admin) },
      ];
    },

    surveyRevisionTypeOptions() {
      return [
        { value: this.SurveyRevisionType.Complaint, text: this.getRevisionTypeText(this.SurveyRevisionType.Complaint) },
        { value: this.SurveyRevisionType.General, text: this.getRevisionTypeText(this.SurveyRevisionType.General) },
        { value: `${this.SurveyRevisionType.General}_${this.SurveyRevisionRole.Creator}`, text: `${this.getRevisionTypeText(this.SurveyRevisionType.General)} - ${this.$t('Webportal.Actions.SurveyRevisionExplorer.AssignedToRole', { role: this.getRevisionRoleText(this.SurveyRevisionRole.Creator)})}` },
        { value: `${this.SurveyRevisionType.General}_${this.SurveyRevisionRole.Contributor}`, text: `${this.getRevisionTypeText(this.SurveyRevisionType.General)} - ${this.$t('Webportal.Actions.SurveyRevisionExplorer.AssignedToRole', { role: this.getRevisionRoleText(this.SurveyRevisionRole.Contributor)})}` }
      ];
    },

    generalInquiryTopicOptions() {
      return [
        { value: null, text: this.$t('Webportal.Actions.InquiryWizard.Step1.PleaseSelect') },
        { value: this.GeneralInquiryTopic.ComplaintDeadline, text: this.getGeneralInquiryTopicText(this.GeneralInquiryTopic.ComplaintDeadline) },
        { value: this.GeneralInquiryTopic.UnderstandRating, text: this.getGeneralInquiryTopicText(this.GeneralInquiryTopic.UnderstandRating) },
        { value: this.GeneralInquiryTopic.GeneralInfo, text: this.getGeneralInquiryTopicText(this.GeneralInquiryTopic.GeneralInfo) },
        { value: this.GeneralInquiryTopic.Technical, text: this.getGeneralInquiryTopicText(this.GeneralInquiryTopic.Technical) },
        { value: this.GeneralInquiryTopic.Evaluation, text: this.getGeneralInquiryTopicText(this.GeneralInquiryTopic.Evaluation) },
        { value: this.GeneralInquiryTopic.ComplaintStatus, text: this.getGeneralInquiryTopicText(this.GeneralInquiryTopic.ComplaintStatus) },
        { value: this.GeneralInquiryTopic.Documentation, text: this.getGeneralInquiryTopicText(this.GeneralInquiryTopic.Documentation) },
        { value: this.GeneralInquiryTopic.Other, text: this.getGeneralInquiryTopicText(this.GeneralInquiryTopic.Other) }
      ];
    }
  },

  methods: {
    userHasActionRevisePermission: function() {
      return AuthenticationService.localUserProfile.Permissions.includes('ActionsRevise');
    },

    userHasActionReviseReadOnlyPermission: function() {
      return AuthenticationService.localUserProfile.Permissions.includes('ActionsReviseReadOnly') && !AuthenticationService.isMSMUser;
    },

    getRevisionRoleText(role) {
      switch (role) {
        case this.SurveyRevisionRole.Creator: return this.$t('Webportal.Actions.SurveyRevision.Role.Creator');
        case this.SurveyRevisionRole.Contributor: return this.$t('Webportal.Actions.SurveyRevision.Role.Contributor');
        case this.SurveyRevisionRole.Agency: return this.$t('Webportal.Actions.SurveyRevision.Role.Agency');
        case this.SurveyRevisionRole.Admin: return this.$t('Webportal.Actions.SurveyRevision.Role.Admin');
        default: return this.$t('Webportal.Actions.SurveyRevision.Role.Unassigned');
      }
    },

    getRevisionRoleIcon(role) {
      switch (role) {
        case this.SurveyRevisionRole.Creator: return 'user-edit';
        case this.SurveyRevisionRole.Contributor: return 'user';
        case this.SurveyRevisionRole.Agency: return 'user-shield';
        case this.SurveyRevisionRole.Admin: return 'user-cog';
        default: return 'user-slash';
      }
    },

    getRevisionTypeText(type) {
      switch (type) {
        case this.SurveyRevisionType.General: return this.$t('Webportal.Actions.GeneralInquiry');
        case this.SurveyRevisionType.Complaint:
        default: return this.$t('Webportal.Actions.SurveyRevision');
      }
    },

    getRevisionTypeIcon(type) {
      switch (type) {
        case this.SurveyRevisionType.General: return 'question-circle';
        case this.SurveyRevisionType.Complaint:
        default: return 'comment-exclamation';
      }
    },

    getGeneralInquiryTopicText(topic) {
      switch (topic) {
        case this.GeneralInquiryTopic.ComplaintDeadline: return this.$t('Webportal.Actions.GeneralInquiryTopic.ComplaintDeadline');
        case this.GeneralInquiryTopic.UnderstandRating: return this.$t('Webportal.Actions.GeneralInquiryTopic.UnderstandRating');
        case this.GeneralInquiryTopic.GeneralInfo: return this.$t('Webportal.Actions.GeneralInquiryTopic.GeneralInfo');
        case this.GeneralInquiryTopic.Technical: return this.$t('Webportal.Actions.GeneralInquiryTopic.Technical');
        case this.GeneralInquiryTopic.Evaluation: return this.$t('Webportal.Actions.GeneralInquiryTopic.Evaluation');
        case this.GeneralInquiryTopic.ComplaintStatus: return this.$t('Webportal.Actions.GeneralInquiryTopic.ComplaintStatus');
        case this.GeneralInquiryTopic.Documentation: return this.$t('Webportal.Actions.GeneralInquiryTopic.Documentation');
        case this.GeneralInquiryTopic.Other:
        default: return this.$t('Webportal.Actions.GeneralInquiryTopic.Other');
      }
    },

    getRevisionCreatedText(surveyRevision) {
      let at = surveyRevision.CreatedAt ? this.$options.filters.msm_timefromnow(surveyRevision.CreatedAt) : null;
      let by = surveyRevision.CreatedBy ?
        `${surveyRevision.CreatedBy.FirstName} ${surveyRevision.CreatedBy.LastName}` +
        (surveyRevision.CreatedBy.Email ? ` (${surveyRevision.CreatedBy.Email})` : '')
        : null;

      return this.$t('Webportal.Created') + ' ' + at +
        (by ? ' ' + this.$t('Webportal.By', { by }) : '');
    },

    getRevisionLastUpdatedText(surveyRevision) {
      let at = this.$options.filters.msm_timefromnow(surveyRevision.ModifiedAt ? surveyRevision.ModifiedAt : surveyRevision.CreatedAt);
      let by = surveyRevision.ModifiedAt && surveyRevision.ModifiedBy ?
        `${surveyRevision.ModifiedBy.FirstName} ${surveyRevision.ModifiedBy.LastName}` :
        !surveyRevision.ModifiedAt && surveyRevision.CreatedBy ?
          `${surveyRevision.CreatedBy.FirstName} ${surveyRevision.CreatedBy.LastName}` : null;

      return this.$t('Webportal.LastUpdated', { at }) +
        (by ? ' ' + this.$t('Webportal.By', { by }) : '');
    },

    getRevisionStatusText(statusId) {
      switch (statusId) {
        case this.SurveyRevisionStatus.New:
          return this.$t('Webportal.Actions.SurveyRevision.StatusNew');
        case this.SurveyRevisionStatus.Approved:
          return this.$t('Webportal.Actions.SurveyRevision.StatusApproved');
        case this.SurveyRevisionStatus.Dismissed:
          return this.$t('Webportal.Actions.SurveyRevision.StatusDismissed');
        case this.SurveyRevisionStatus.DismissedCustom1:
          return this.$t('Webportal.Actions.SurveyRevision.StatusDismissedCustom1');
        case this.SurveyRevisionStatus.DismissedCustom2:
          return this.$t('Webportal.Actions.SurveyRevision.StatusDismissedCustom2');
        case this.SurveyRevisionStatus.DismissedCustom3:
          return this.$t('Webportal.Actions.SurveyRevision.StatusDismissedCustom3');
        case this.SurveyRevisionStatus.InProgress:
          return this.$t('Webportal.Actions.SurveyRevision.StatusAcceptedInProgress');
        case this.SurveyRevisionStatus.InProgressAgency:
          return this.$t('Webportal.Actions.SurveyRevision.StatusInProgressAgency');
        case this.SurveyRevisionStatus.InProgressCustom1:
          return this.$t('Webportal.Actions.SurveyRevision.StatusInProgressCustom1');
        case this.SurveyRevisionStatus.InProgressCustom2:
          return this.$t('Webportal.Actions.SurveyRevision.StatusInProgressCustom2');
        case this.SurveyRevisionStatus.Recheck:
          return this.$t('Webportal.Actions.SurveyRevision.StatusRecheck');
        case this.SurveyRevisionStatus.Solved:
          return this.$t('Webportal.Actions.SurveyRevision.StatusSolved');
        case this.SurveyRevisionStatus.Revised:
          return this.$t('Webportal.Actions.SurveyRevision.StatusRevised');
        case this.SurveyRevisionStatus.RevisedApprovedGoodwill:
          return this.$t('Webportal.Actions.SurveyRevision.StatusRevisedGoodwill');
        case this.SurveyRevisionStatus.RevisedApprovedCustom1:
          return this.$t('Webportal.Actions.SurveyRevision.StatusRevisedApprovedCustom1');
        case this.SurveyRevisionStatus.RevisedApprovedCustom2:
          return this.$t('Webportal.Actions.SurveyRevision.StatusRevisedApprovedCustom2');
        case this.SurveyRevisionStatus.RevisedApprovedCustom3:
          return this.$t('Webportal.Actions.SurveyRevision.StatusRevisedApprovedCustom3');
        case this.SurveyRevisionStatus.RevisedApproved:
          return this.$t('Webportal.Actions.SurveyRevision.StatusRevisedApproved');
        case this.SurveyRevisionStatus.RevisedDismissed:
          return this.$t('Webportal.Actions.SurveyRevision.StatusRevisedDismissed');
        case this.SurveyRevisionStatus.RevisedDismissedCustom1:
          return this.$t('Webportal.Actions.SurveyRevision.StatusRevisedDismissedCustom1');
        case this.SurveyRevisionStatus.RevisedDismissedCustom2:
          return this.$t('Webportal.Actions.SurveyRevision.StatusRevisedDismissedCustom2');
        case this.SurveyRevisionStatus.RevisedDismissedCustom3:
          return this.$t('Webportal.Actions.SurveyRevision.StatusRevisedDismissedCustom3');
        case this.SurveyRevisionStatus.Done:
          return this.$t('Webportal.Actions.SurveyRevision.StatusDone');
        case this.SurveyRevisionStatus.Answered:
          return this.$t('Webportal.Actions.SurveyRevision.StatusAnswered');
        case this.SurveyRevisionStatus.Published:
          return this.$t('Webportal.Actions.SurveyRevision.StatusPublished');
      }
    },

    formatFileSize(bytes) {
      if (bytes < 1024) return bytes + " B";
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
      return (bytes / (1024 * 1024)).toFixed(1) + " MB";
    },

    getDocumentTypeIcon(documentType) {
      const icons = {
        telephone: "phone",
        email: "envelope",
        picture: "camera",
        video: "video",
        receipt: "file-invoice",
        other: "file",
      };
      return icons[documentType] || "file";
    },

    getDocumentTypeLabel(documentType) {
      const labels = {
        telephone: this.$t('Webportal.Actions.InquiryWizard.Attachment.DocumentType.Telephone'),
        email: this.$t('Webportal.Actions.InquiryWizard.Attachment.DocumentType.Email'),
        picture: this.$t('Webportal.Actions.InquiryWizard.Attachment.DocumentType.Picture'),
        video: this.$t('Webportal.Actions.InquiryWizard.Attachment.DocumentType.Video'),
        receipt: this.$t('Webportal.Actions.InquiryWizard.Attachment.DocumentType.Receipt'),
        other: this.$t('Webportal.Actions.InquiryWizard.Attachment.DocumentType.Other'),
      };
      return labels[documentType] || documentType;
    },

    getRevisionStatusIcon(statusId) {
      switch (statusId) {
        case this.SurveyRevisionStatus.New:
          return "exclamation-circle";
        case this.SurveyRevisionStatus.Dismissed:
        case this.SurveyRevisionStatus.DismissedCustom1:
        case this.SurveyRevisionStatus.DismissedCustom2:
        case this.SurveyRevisionStatus.DismissedCustom3:
        case this.SurveyRevisionStatus.RevisedDismissed:
        case this.SurveyRevisionStatus.RevisedDismissedCustom1:
        case this.SurveyRevisionStatus.RevisedDismissedCustom2:
        case this.SurveyRevisionStatus.RevisedDismissedCustom3:
          return "times-circle";
        case this.SurveyRevisionStatus.InProgress:
        case this.SurveyRevisionStatus.InProgressAgency:
        case this.SurveyRevisionStatus.InProgressCustom1:
        case this.SurveyRevisionStatus.InProgressCustom2:
        case this.SurveyRevisionStatus.Recheck:
          return "play-circle";
        case this.SurveyRevisionStatus.Approved:
        case this.SurveyRevisionStatus.Solved:
        case this.SurveyRevisionStatus.Revised:
        case this.SurveyRevisionStatus.RevisedApprovedGoodwill:
        case this.SurveyRevisionStatus.RevisedApprovedCustom1:
        case this.SurveyRevisionStatus.RevisedApprovedCustom2:
        case this.SurveyRevisionStatus.RevisedApprovedCustom3:
        case this.SurveyRevisionStatus.RevisedApproved:
        case this.SurveyRevisionStatus.Answered:
          return "check-circle";
        case this.SurveyRevisionStatus.Done:
          return "dot-circle";
        case this.SurveyRevisionStatus.Published:
          return "globe";
        default:
          return "question-circle";
      }
    },

    isSurveyRevisionAllowed(surveyInstance) {
      return surveyInstance.IsVisibleForQuery;
    },

    getHistoryEventTypeLabel(historyEvent) {
      switch (historyEvent.EventType) {
        case 'CheckSubmitted':
          return this.$t('Webportal.Actions.InquiryWizard.History.CheckSubmitted');
        case 'CheckReportCreated':
          return this.$t('Webportal.Actions.InquiryWizard.History.CheckReportCreated');
        case 'CheckReportModified':
          return this.$t('Webportal.Actions.InquiryWizard.History.CheckReportModified');
        case 'CheckReleased':
          return this.$t('Webportal.Actions.InquiryWizard.History.CheckReleased');
        case 'CheckViewed':
          return this.$t('Webportal.Actions.InquiryWizard.History.CheckViewed');
        case 'RevisionCreated':
          return this.$t('Webportal.Actions.InquiryWizard.History.RevisionCreated', { id: historyEvent.SurveyRevisionVisibleId ? ' #' + historyEvent.SurveyRevisionVisibleId : '' });
        case 'RevisionCommentAdded':
          return this.$t('Webportal.Actions.InquiryWizard.History.RevisionCommentAdded', { id: historyEvent.SurveyRevisionVisibleId ? ' #' + historyEvent.SurveyRevisionVisibleId : '' });
        case 'RevisionStatusChanged':
          return this.$t('Webportal.Actions.InquiryWizard.History.RevisionStatusChanged', { id: historyEvent.SurveyRevisionVisibleId ? ' #' + historyEvent.SurveyRevisionVisibleId : '' });
        default:
          return historyEvent.EventType;
      }
    },

    getHistoryEventTypeDescription(historyEvent) {
      switch (historyEvent.EventType) {
        case 'CheckSubmitted':
          return this.$t('Webportal.Actions.InquiryWizard.History.CheckSubmitted.Description');
        case 'CheckReportCreated':
          return this.$t('Webportal.Actions.InquiryWizard.History.CheckReportCreated.Description');
        case 'CheckReportModified':
          return this.$t('Webportal.Actions.InquiryWizard.History.CheckReportModified.Description');
        case 'CheckReleased':
          return this.$t('Webportal.Actions.InquiryWizard.History.CheckReleased.Description');
        case 'CheckViewed':
          return this.$t('Webportal.Actions.InquiryWizard.History.CheckViewed.Description');
        case 'RevisionCreated':
          return this.$t('Webportal.Actions.InquiryWizard.History.RevisionCreated.Description');
        case 'RevisionCommentAdded':
          return this.$t('Webportal.Actions.InquiryWizard.History.RevisionCommentAdded.Description');
        case 'RevisionStatusChanged':
          return this.$t('Webportal.Actions.InquiryWizard.History.RevisionStatusChanged.Description', { status: this.getRevisionStatusText(historyEvent.NewStatusId) });
        default:
          return historyEvent.EventType;
      }
    }
  }
};
